/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from '@azure/msal-browser';
import configs from '../configs';

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
const isNotPc = window.navigator.userAgent?.match(
  /Mobile|Android|iPhone|iPad|iPod/i,
);
const isAndroid = window.navigator.userAgent?.match(/Android/i);

export const msalConfig = {
  auth: {
    clientId:
      configs.env === 'prod'
        ? 'c9e30bd6-e649-4e16-b3cb-29cd4b9f04bc'
        : '634e5242-d1a3-4950-bf86-fd28402d55ea',
    authority:
      'https://login.microsoftonline.com/cef04b19-7776-4a94-b89b-375c77a8f936',
    redirectUri:
      configs.env === 'prod'
        ? 'https://sensoryone.ab-inbev.com'
        : 'https://sensoryone-qa.ab-inbev.com',
  },
  cache: {
    cacheLocation: isNotPc ? 'sessionStorage' : 'localStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
      },
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */

export const loginRequest = isAndroid
  ? {
      scopes: ['User.Read'],
      prompt: 'login',
    }
  : {
      scopes: ['User.Read'],
    };

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};

